// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--eL7UE","icon":"_93444fe79c--icon--qoeQb","remoteness":"_93444fe79c--remoteness--He1zh"};